/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win1_TInputs */

const en_wc_vs_win1_t = /** @type {(inputs: Wc_Vs_Win1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cost, no subscription`)
};

/**
* | output |
* | --- |
* | "No cost, no subscription" |
*
* @param {Wc_Vs_Win1_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win1_t = /** @type {((inputs?: Wc_Vs_Win1_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win1_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win1_t(inputs)
});
export { wc_vs_win1_t as "wc.vs.win1.t" }